import * as z from 'zod';

const GradientZod = z.object({
  start: z.string(),
  end: z.string(),
});

export { GradientZod };
export type GradientType = z.infer<typeof GradientZod>;
